import React from "react";
import { Box, Theme, Typography, useMediaQuery } from "@mui/material";
import Carousel from "react-material-ui-carousel";
import { useTheme } from "@mui/styles";
import { BenefitItem } from "../AccountBenefits";
import saveTime1 from "../../assets/auth-save-time-1x.png";
import saveTime2 from "../../assets/auth-save-time-2x.png";
import saveTime3 from "../../assets/auth-save-time-3x.png";
import support1 from "../../assets/auth-support-1x.png";
import support2 from "../../assets/auth-support-2x.png";
import support3 from "../../assets/auth-support-3x.png";
import protection1 from "../../assets/auth-protection-1x.png";
import protection2 from "../../assets/auth-protection-2x.png";
import protection3 from "../../assets/auth-protection-3x.png";
import { BackgroundCircle } from "../../shared/BackgroundCircle";
import { getCarouselStyles } from "../AuthScreen";

const benefitCarouselItems: BenefitItem[] = [
  {
    imgs: [saveTime1, saveTime2, saveTime3],
    title: "Save time and money, focus on family",
    desc: "Save hundreds of hours searching for answers and thousands of dollars in unnecessary fees.",
    styles: {
      width: "55%",
    },
  },
  {
    imgs: [support1, support2, support3],
    title: "Dedicated support, from start to finish",
    desc: "Our team of experts are prepared to help, down to the specifics of your state and county.",
    styles: {
      width: "66%",
    },
  },
  {
    imgs: [protection1, protection2, protection3],
    title: "Liability protection, guaranteed",
    desc: "Protect your family and estate from surprise debt collection when you least expect it.",
  },
];

export const DefaultContent = (): JSX.Element => {
  const theme = useTheme();

  const isNarrow = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  return (
    <Box className="DefaultContent">
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h4">
          All the forms, tools, and guidance you need to settle an estate with
          confidence
        </Typography>
      </Box>
      <Box
        sx={{
          mt: 2,
        }}
      >
        <Carousel
          className="DefaultContentCarousel"
          indicators={true}
          autoPlay={true}
          animation="slide"
          height={isNarrow ? 300 : 400}
          indicatorContainerProps={
            getCarouselStyles(theme)?.indicatorContainerProps
          }
          indicatorIconButtonProps={
            getCarouselStyles(theme)?.indicatorIconButtonProps
          }
          activeIndicatorIconButtonProps={
            getCarouselStyles(theme)?.activeIndicatorIconButtonProps
          }
        >
          {benefitCarouselItems?.map((item: BenefitItem) => (
            <Box
              key={item.title}
              sx={{
                textAlign: "center",
                "& > img": {
                  m: isNarrow ? 1 : 4,
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: isNarrow ? 1 : 3,
                  mb: isNarrow ? 3 : 5,
                }}
              >
                <BackgroundCircle
                  width={isNarrow ? 160 : 260}
                  borderColor={`${theme.palette.success.main}`}
                >
                  <img
                    src={item?.imgs?.[0]}
                    srcSet={`${item?.imgs?.[1]} 2x, ${item?.imgs?.[2]} 3x`}
                    alt={item.title}
                    style={item.styles}
                  />
                </BackgroundCircle>
              </Box>

              <Typography
                variant="h4"
                sx={{
                  mb: 2,
                }}
              >
                {item.title}
              </Typography>
              <Typography>{item.desc}</Typography>
            </Box>
          ))}
        </Carousel>
      </Box>
    </Box>
  );
};
